<template>
	<tr :data-hover="hover" :data-clickable="clickable" :data-blink="blink">
		<slot />
	</tr>
</template>
<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
	name: "TableRow",

	props: {
		hover: {
			type: Boolean,
			default: () => true
		},

		clickable: {
			type: Boolean,
			default: () => false
		},

		blink: {
			type: Boolean,
			default: () => false
		}
	}
});
</script>
<style lang="scss">
div.flow-table-component {
	tr[data-clickable] {
		cursor: pointer;
	}
	tr[data-hover] {
		&:hover {
			> * {
				background-color: var(--gray-500);
			}
		}
	}
	tr[data-blink="true"] {
		> * {
			animation: td-pulse 2s infinite;
		}
	}

	@keyframes td-pulse {
		0% {
			background-color: var(--gray-500);
		}
		50% {
			background-color: var(--gray-600);
		}
		100% {
			background-color: var(--gray-500);
		}
	}
}
</style>
